var map = {
	"./icon_arrow.svg": "./assets/private/img/volvo-icons/icon_arrow.svg",
	"./icon_battery_with_plug.svg": "./assets/private/img/volvo-icons/icon_battery_with_plug.svg",
	"./icon_build_your_own.svg": "./assets/private/img/volvo-icons/icon_build_your_own.svg",
	"./icon_calendar.svg": "./assets/private/img/volvo-icons/icon_calendar.svg",
	"./icon_calendar_2.svg": "./assets/private/img/volvo-icons/icon_calendar_2.svg",
	"./icon_car.svg": "./assets/private/img/volvo-icons/icon_car.svg",
	"./icon_check.svg": "./assets/private/img/volvo-icons/icon_check.svg",
	"./icon_close.svg": "./assets/private/img/volvo-icons/icon_close.svg",
	"./icon_cloud.svg": "./assets/private/img/volvo-icons/icon_cloud.svg",
	"./icon_dashboard.svg": "./assets/private/img/volvo-icons/icon_dashboard.svg",
	"./icon_delete_input.svg": "./assets/private/img/volvo-icons/icon_delete_input.svg",
	"./icon_direction.svg": "./assets/private/img/volvo-icons/icon_direction.svg",
	"./icon_email.svg": "./assets/private/img/volvo-icons/icon_email.svg",
	"./icon_emergency_help.svg": "./assets/private/img/volvo-icons/icon_emergency_help.svg",
	"./icon_emission.svg": "./assets/private/img/volvo-icons/icon_emission.svg",
	"./icon_expand.svg": "./assets/private/img/volvo-icons/icon_expand.svg",
	"./icon_filter.svg": "./assets/private/img/volvo-icons/icon_filter.svg",
	"./icon_finance.svg": "./assets/private/img/volvo-icons/icon_finance.svg",
	"./icon_fleet_service.svg": "./assets/private/img/volvo-icons/icon_fleet_service.svg",
	"./icon_get_direction.svg": "./assets/private/img/volvo-icons/icon_get_direction.svg",
	"./icon_handling.svg": "./assets/private/img/volvo-icons/icon_handling.svg",
	"./icon_information.svg": "./assets/private/img/volvo-icons/icon_information.svg",
	"./icon_insurance.svg": "./assets/private/img/volvo-icons/icon_insurance.svg",
	"./icon_interior.svg": "./assets/private/img/volvo-icons/icon_interior.svg",
	"./icon_list_view.svg": "./assets/private/img/volvo-icons/icon_list_view.svg",
	"./icon_login.svg": "./assets/private/img/volvo-icons/icon_login.svg",
	"./icon_map_alternate.svg": "./assets/private/img/volvo-icons/icon_map_alternate.svg",
	"./icon_map_pin.svg": "./assets/private/img/volvo-icons/icon_map_pin.svg",
	"./icon_map_pin_checked.svg": "./assets/private/img/volvo-icons/icon_map_pin_checked.svg",
	"./icon_map_pin_filled.svg": "./assets/private/img/volvo-icons/icon_map_pin_filled.svg",
	"./icon_map_pin_fully_filled.svg": "./assets/private/img/volvo-icons/icon_map_pin_fully_filled.svg",
	"./icon_market_selector.svg": "./assets/private/img/volvo-icons/icon_market_selector.svg",
	"./icon_menu.svg": "./assets/private/img/volvo-icons/icon_menu.svg",
	"./icon_my_volvo.svg": "./assets/private/img/volvo-icons/icon_my_volvo.svg",
	"./icon_newsletter.svg": "./assets/private/img/volvo-icons/icon_newsletter.svg",
	"./icon_notebook.svg": "./assets/private/img/volvo-icons/icon_notebook.svg",
	"./icon_offer.svg": "./assets/private/img/volvo-icons/icon_offer.svg",
	"./icon_overlay.svg": "./assets/private/img/volvo-icons/icon_overlay.svg",
	"./icon_owners_manual.svg": "./assets/private/img/volvo-icons/icon_owners_manual.svg",
	"./icon_print.svg": "./assets/private/img/volvo-icons/icon_print.svg",
	"./icon_rain.svg": "./assets/private/img/volvo-icons/icon_rain.svg",
	"./icon_request_a_quote.svg": "./assets/private/img/volvo-icons/icon_request_a_quote.svg",
	"./icon_road.svg": "./assets/private/img/volvo-icons/icon_road.svg",
	"./icon_roadside_assistance.svg": "./assets/private/img/volvo-icons/icon_roadside_assistance.svg",
	"./icon_search.svg": "./assets/private/img/volvo-icons/icon_search.svg",
	"./icon_security.svg": "./assets/private/img/volvo-icons/icon_security.svg",
	"./icon_smartphone.svg": "./assets/private/img/volvo-icons/icon_smartphone.svg",
	"./icon_snow.svg": "./assets/private/img/volvo-icons/icon_snow.svg",
	"./icon_steering_wheel.svg": "./assets/private/img/volvo-icons/icon_steering_wheel.svg",
	"./icon_sunshine.svg": "./assets/private/img/volvo-icons/icon_sunshine.svg",
	"./icon_support.svg": "./assets/private/img/volvo-icons/icon_support.svg",
	"./icon_view_website.svg": "./assets/private/img/volvo-icons/icon_view_website.svg",
	"./icon_wifi.svg": "./assets/private/img/volvo-icons/icon_wifi.svg",
	"./icon_wrench.svg": "./assets/private/img/volvo-icons/icon_wrench.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./assets/private/img/volvo-icons sync \\.(png|jpe?g|svg)$";